import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable()
export class ToastService {
  constructor(private messageService: MessageService) {}

  showWarnToast(summaryParam: string, detailParam: string) {
    this.messageService.add({
      severity: "warn",
      summary: summaryParam,
      detail: detailParam,
    });
  }

  showErrorToast(summaryParam: string, detailParam: string) {
    this.messageService.add({
      severity: "error",
      summary: summaryParam,
      detail: detailParam,
    });
  }

  showSuccesToast(summaryParam: string, detailParam: string) {
    this.messageService.add({
      severity: "success",
      summary: summaryParam,
      detail: detailParam,
    });
  }
}
